import { Avatar, Box, Typography, useTheme } from '@mui/material';
import { SectionCard } from '@modules/talents/components/SectionCard';
import { SectionTitle } from '@modules/talents/components/SectionTitle';
import { Link } from 'react-router-dom';

interface ProCardProps {
    pro: {
        _id: string;
        name?: string;
        commercialName?: string;
        city?: string;
        brandLogo?: { url?: string } | null;
    };
}

const ProCard = ({ pro }: ProCardProps) => {
    const theme = useTheme();
    const displayName = pro.commercialName || pro.name || '-';

    return (
        <SectionCard>
            <SectionTitle title="Entreprise" />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
                    <Avatar
                        src={pro.brandLogo?.url ?? '/default-logo.png'}
                        alt={displayName}
                        sx={{ width: 40, height: 40, bgcolor: theme.palette.transparentPurple.main, borderRadius: '50%' }}
                    >
                        {displayName?.[0]}
                    </Avatar>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography component={Link} to={`/companies/${pro._id}/edit`} variant="subtitle2" fontWeight={700} noWrap sx={{ color: theme.palette.text.primary }}> 
                            {displayName}
                        </Typography>
                        <br />
                        {pro.city && (
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                {pro.city}
                            </Typography>
                        )}
                    </Box>
                </Box>
        </SectionCard>
    );
};

export default ProCard;
